import AssetsManager from '../../../data/AssetsManager'
import DataManager from '../../../data/DataManager'
import RankingView from '../../../ranking/RankingView';

/**
 * TopViewクラス
 */
class TopView extends PIXI.Container {
  // ---------------------------------------------------------------------------------------------------------
  // --	TopView
  // ---------------------------------------------------------------------------------------------------------

  /**
   * コンストラクタ
   */
  constructor() {
    super();

    console.log('Top');

    //app参照
    this.app = DataManager.getData('app');

    //コンフィグ
    this.config = AssetsManager.getConfig();

    //初期サイズ
    this.size = {
      width	:this.config.STAGE_WIDTH,
      height	:this.config.STAGE_HEIGHT
    };

    //コンテナ
    this.container = new PIXI.Container();
    this.addChild(this.container);

    //タイトル配置
    this.title = AssetsManager.createSprite("title.png");
    this.title.anchor.set(0.5, 0.5);
    this.title.scale.set(4, 4);
    this.title.y = -100;
    this.container.addChild(this.title);

    //スタートボタン
    this.startButton = new PIXI.Text('START',{fontFamily : 'BIT', fontSize: 32, fill : 0xFFFFFF, align : 'center'});
    this.startButton.anchor.set(0.5, 1.0);
    this.startButton.y = 100;
    this.container.addChild(this.startButton);
    this.startButton.interactive = true;
    this.startButton.on('mousedown', () => {
      AssetsManager.playSound('sound_click')
      this.emit('start');
    });
    this.startButton.on('touchstart', () => {
      AssetsManager.playSound('sound_click')
      this.emit('start');
    });

    //ランキングボタン
    this.rankingButton = new PIXI.Text('RANKING',{fontFamily : 'BIT', fontSize: 32, fill : 0xFFFFFF, align : 'center'});
    this.rankingButton.anchor.set(0.5, 1.0);
    this.rankingButton.x = this.startButton.x;
    this.rankingButton.y = this.startButton.y + 80;
    this.container.addChild(this.rankingButton);
    this.rankingButton.interactive = true;
    this.rankingButton.on('mousedown', () => {
      AssetsManager.playSound('sound_click')
      RankingView.open();
    });
    this.rankingButton.on('touchstart', () => {
      AssetsManager.playSound('sound_click')
      RankingView.open();
    });
  }

  /**
   * リセット
   */
  reset()
  {
    this.visible = false;
  }

	// --------------------------------------------------------------------------------------------------------------------------------------
	// --	 開く/閉じる
	// --------------------------------------------------------------------------------------------------------------------------------------

  /**
   * 開く
   */
  open()
	{
    //ボタン
    this.startButton.text = "START";
    this.rankingButton.text = "RANKING";
    
    //表示
    this.visible = true;
	}
  
  /**
   * 閉じる
   */
  close()
	{
    //リセット
		this.reset();
	}
    

	// --------------------------------------------------------------------------------------------------------------------------------------
	// --	 リサイズ
	// --------------------------------------------------------------------------------------------------------------------------------------
	
	resize()
	{
		//コンテナの位置
    this.container.x = Math.floor(this.app.renderer.width/2);
    this.container.y = Math.floor(this.app.renderer.height/2);
	}
    
  // ---------------------------------------------------------------------------------------------------------
}

export default TopView
